import { DefaultError } from "../-components/error-context"
import { ProblemDetails } from "../@client/Microsoft_AspNetCore_Mvc"
import { isFsharpErrorResult } from "./is-fsharp-error-result"

export async function handleResponse<ReturnType>(response: Response) {
  const contentTypeHeader = response.headers.get("Content-Type")
  const isJson =
    contentTypeHeader?.includes("application/json") ||
    contentTypeHeader?.includes("application/problem+json")

  const content: ReturnType = await (isJson ? response.json() : response.text())

  if (response.status === 426) {
    // reload with cache busting
    window.location.href =
      window.location.href.split("?")[0] + "?noCache=" + Date.now()
  }

  if (response.ok) {
    if (isFsharpErrorResult(content)) {
      throw new DefaultError({
        title: "Error Result",
        detail: content.Fields,
      })
    } else return content
  } else {
    throw new DefaultError(content as ProblemDetails)
  }
}
